/**
 * @author       yontaek@zumper.com (Yon Taek Chung)
 * @copyright    Copyright (c) 2022, Zumper
 */

import { createAction } from 'redux-actions'
import {
  SET_FREEZE_BOX,
  SET_IS_NAVBAR_EXPANDED,
  SET_MOBILE_VIEW_TYPE,
  SET_SHORT_TERM_CALENDAR_OPEN,
  UPDATE_SEARCH_UI,
} from './constants'

export const setIsNavbarExpanded = createAction<boolean, typeof SET_IS_NAVBAR_EXPANDED>(
  SET_IS_NAVBAR_EXPANDED
)

/* SEARCH UI */
export const updateSearchUI = createAction<{ key: string; value: string }, typeof UPDATE_SEARCH_UI>(
  UPDATE_SEARCH_UI
)

export const setShortTermCalendarPickerOpen = createAction(SET_SHORT_TERM_CALENDAR_OPEN)

// navbar
export const setMobileViewType = createAction<string, typeof SET_MOBILE_VIEW_TYPE>(
  SET_MOBILE_VIEW_TYPE
)

// Current Search View
export const setFreezeBox = createAction<boolean, typeof SET_FREEZE_BOX>(SET_FREEZE_BOX)
